import React from "react";
import Portfolio from "./components/Portfolio";

function App() {
  return (
    <div>
      <Portfolio />
    </div>
  );
}

export default App;
